export default {"src":"/_next/static/media/500-light.e1893432.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};